import { module } from 'angular';

import AccountInfosController from '~/pages/account/infos/account-infos.controller';
import AccountMailingController from '~/pages/account/mailing/account-mailing.controller';
import AccountPasswordController from '~/pages/account/password/account-password.controller';
import AccountWorkflowController from '~/pages/account/workflow/account-workflow.controller';
import accountMenuComponent from './account-menu/account-menu.component';
import accountPageComponent from './account-page/account-page.component';

export default module('app.account', [])
	.component('accountMenu', accountMenuComponent)
	.component('accountPage', accountPageComponent)
	.controller('AccountInfosController', AccountInfosController)
	.controller('AccountMailingController', AccountMailingController)
	.controller('AccountPasswordController', AccountPasswordController)
	.controller('AccountWorkflowController', AccountWorkflowController)
	.name;
